
export const EventMessageService = {
    sendMessageEvent: (msg: string) => {
        const objMessage = {
            type: 'BANKREADER_PEPPER',
            message: msg
          }
          window.parent.postMessage(objMessage, "*");
    }
}